export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended',
}

export type UserRole = 'Admin' | 'User' | 'Viewer'

export interface User {
  id: string
  email: string
  displayName: string
  avatarUrl?: string
  role: UserRole
  status: UserStatus
  isSuperAdmin: boolean
  isDevAdmin: boolean
  tenantId?: string
  lastLoginAt?: string
  createdAt: string
  updatedAt?: string
}
